"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const executeProcessesFactory_1 = __importDefault(require("../applicationFunctionality/executeProcessesFactory"));
const createRunnableProcess_1 = __importDefault(require("./createRunnableProcess"));
const createEmptyFunctionOutputs_1 = __importDefault(require("./createEmptyFunctionOutputs"));
const General_1 = require("../types/General");
const controlCreateEventCallbackFromDefinition = ({ appStateStore, processor, functionsDefinitions, controlEvent, controlId, }) => {
    const functionIds = controlEvent[General_1.DEFINITION_PROP_NAMES.FUNCTION_IDS];
    const controlContext = processor.root.getControlRunContext(controlId);
    const processes = (functionIds || [])
        .reduce((result, processId) => {
        const process = (0, createRunnableProcess_1.default)({
            store: appStateStore,
            functionId: processId,
            processor,
            extraFunctionDefinitions: controlContext === null || controlContext === void 0 ? void 0 : controlContext.extraFunctionDefinitions,
            functionsDefinitions,
        });
        if (process) {
            result.push(process);
        }
        return result;
    }, []);
    return (eventOutputs) => {
        // HERE IT DOES NOT CHANGE
        (0, executeProcessesFactory_1.default)({
            store: appStateStore,
            processor: (controlContext === null || controlContext === void 0 ? void 0 : controlContext.processor) || processor,
            controlCallerId: controlId,
            eventOutputs,
            lastFunctionsOutputs: (controlContext === null || controlContext === void 0 ? void 0 : controlContext.lastFunctionsOutputs)
                || (0, createEmptyFunctionOutputs_1.default)(),
        })(undefined, processes);
    };
};
exports.default = controlCreateEventCallbackFromDefinition;
